import { render, staticRenderFns } from "./preSale.vue?vue&type=template&id=0395605e"
import script from "./preSale.vue?vue&type=script&lang=js"
export * from "./preSale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports